

































import { ApiCreditcard } from '@/models/api/creditcard'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component
export default class ShowCreditcard extends Vue {
  @Prop({ required: true })
  selectedCreditcard: ApiCreditcard

  @Emit('change-creditcard')
  change() {
    // do nothing
  }

  @Emit('select-creditcard')
  select() {
    // do nothing
  }
}
